// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetQuestionAnswersRequest,
  TGetQuestionAnswersModel,
  IMappers,
  TGetQuestionAnswersResponse,
  IGetQuestionAnswersResponse,
  IGetQuestionAnswersResponseError,
} from './types';

export const defaultConfig: TGetQuestionAnswersModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/get-question-answers/',
  requestType: 'json',
} as TGetQuestionAnswersModel;

export function createGetQuestionAnswersModel(parameters: IGetQuestionAnswersRequest): TGetQuestionAnswersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetQuestionAnswersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetQuestionAnswersRequest;
}

export async function fetchGetQuestionAnswers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetQuestionAnswersOptions<TResponse200, TResponse400>): Promise<
  TGetQuestionAnswersResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetQuestionAnswersModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetQuestionAnswersResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetQuestionAnswersResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetQuestionAnswersResponse;
}
